import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2c960f6a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "pro_header flex_ac"
};
var _hoisted_2 = {
  class: "main flex_jcsb_ac"
};
var _hoisted_3 = {
  class: "base flex_ac"
};
var _hoisted_4 = {
  key: 0,
  class: "status flex_ac"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "iconfont icon-yonghu-yuan"
  }, null, -1);
});

var _hoisted_6 = {
  class: "el-dropdown-link"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode("修改密码");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("退出登录");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_arrow_down = _resolveComponent("arrow-down");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  var _component_el_dropdown = _resolveComponent("el-dropdown");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.outerLink && $setup.outerLink.apply($setup, arguments);
    })
  }), !$setup.isLogin ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "welcome",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.innerLink('/login');
    })
  }, "欢迎登录")) : _createCommentVNode("", true)]), $setup.isLogin ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", {
    class: "home",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $setup.innerLink('/');
    })
  }, "首页"), _hoisted_5, _createVNode(_component_el_dropdown, {
    size: "large",
    placement: "bottom-start"
  }, {
    dropdown: _withCtx(function () {
      return [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_dropdown_item, {
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return $setup.innerLink('/updatePassword');
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            onClick: $setup.logout
          }, {
            default: _withCtx(function () {
              return [_hoisted_8];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      })];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.$store.state.user.profile.Name) + " ", 1), _createVNode(_component_el_icon, {
        class: "el-icon--right"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_arrow_down)];
        }),
        _: 1
      })])];
    }),
    _: 1
  })])) : _createCommentVNode("", true)])]);
}